export const PAYOUT_REQUEST_COLLAPSE_TEST_ID = 'payouts-detail-payout-request';

export const CANCEL_PAYOUT_BUTTON_TEST_ID =
  'payouts-detail-cancel-payout-button';
